import Route from '@ember/routing/route';
import { schedule } from '@ember/runloop';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import JournalService from 'donor-elf-web/services/journal-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import TaskService from 'donor-elf-web/services/task-service';
import type { JournalParams } from '../journal';

export default class JournalsIndexRoute extends Route {
  @service declare journalService: JournalService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;
  @service declare taskService: TaskService;

  beforeModel() {
    schedule('render', this, () => {
      this.navbarSettings.enableFluidContainer = true;
    });
  }

  async model() {
    await this.taskService.load();
    await this.journalService.load();
    let journalId = (
      this.paramsFor('funds.fund.journals.journal') as JournalParams
    ).journalId;
    let journalInfo = this.journalService.journalInfoById(journalId);
    this.navbarSettings.title = `${journalInfo.journal.label} Journal`;
    let journalDashboard = (
      (await this.store.query('journal-dashboard', {
        filter: { journal_ids: journalId },
      })) as any
    )[0];
    return {
      journalInfo,
      journalDashboard,
    };
  }

  deactivate() {
    this.navbarSettings.enableFluidContainer = false;
  }
}
